(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;

  /* ------------------------------------------------------------------ */
  /*  Variant data — read straight from DOM attributes                   */
  /* ------------------------------------------------------------------ */
  const variantRows = document.querySelectorAll('[data-variant-row]');
  const variants = Array.from(variantRows).map((el) => ({
    id: el.dataset.variantId,
    options: (el.dataset.variantOptions || '').split('||'),
    price: el.dataset.variantPrice || '',
    available: el.dataset.variantAvailable === '1',
    sku: el.dataset.variantSku || '',
    imagePos: parseInt(el.dataset.variantImagePos || '0', 10),
  }));
  const optionNames = Array.from(root.querySelectorAll('[data-variant-group]'))
    .sort((a, b) => parseInt(a.dataset.optionIndex, 10) - parseInt(b.dataset.optionIndex, 10))
    .map((g) => g.querySelector('[data-variant-option]')?.dataset.optionName || '');

  /* ------------------------------------------------------------------ */
  /*  Gallery                                                            */
  /* ------------------------------------------------------------------ */
  const thumbs = root.querySelectorAll('[data-product-thumb]');
  const images = root.querySelectorAll('[data-product-image]');
  const mainContainer = root.querySelector('[data-product-main]');
  let currentImage = 0;

  const showImage = (index) => {
    if (index < 0 || index >= images.length) return;
    currentImage = index;

    images.forEach((el, i) => el.classList.toggle('hidden', i !== index));

    thumbs.forEach((t, i) => {
      const active = i === index;
      t.classList.toggle('border-primary', active);
      t.classList.toggle('border-border', !active);
      t.setAttribute('aria-current', String(active));
    });
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const idx = parseInt(thumb.dataset.index, 10);
      showImage(idx);
    });
  });

  /* ------------------------------------------------------------------ */
  /*  Hover zoom                                                         */
  /* ------------------------------------------------------------------ */
  const zoomHint = root.querySelector('[data-product-zoom-hint]');
  let zooming = false;

  const getActiveImg = () => images[currentImage]?.querySelector('img');

  if (mainContainer && window.matchMedia('(pointer: fine)').matches) {
    mainContainer.addEventListener('mouseenter', () => {
      zooming = true;
      zoomHint?.classList.add('opacity-0');
      const img = getActiveImg();
      if (img) img.style.transform = 'scale(2)';
    });
    mainContainer.addEventListener('mouseleave', () => {
      zooming = false;
      zoomHint?.classList.remove('opacity-0');
      const img = getActiveImg();
      if (img) {
        img.style.transform = '';
        img.style.transformOrigin = '';
      }
    });
    mainContainer.addEventListener('mousemove', (e) => {
      if (!zooming) return;
      const rect = mainContainer.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      const img = getActiveImg();
      if (img) img.style.transformOrigin = `${x}% ${y}%`;
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Lightbox                                                           */
  /* ------------------------------------------------------------------ */
  const lightbox = document.querySelector('[data-product-lightbox]');
  const lbImage = lightbox?.querySelector('[data-product-lightbox-image]');
  const lbCurrent = lightbox?.querySelector('[data-product-lightbox-current]');
  const lbTotal = lightbox?.querySelector('[data-product-lightbox-total]');
  const lbThumbs = lightbox?.querySelector('[data-product-lightbox-thumbs]');

  const imageSrcs = Array.from(images).map((el) => el.querySelector('img')?.src || '');
  const imageAlts = Array.from(images).map((el) => el.querySelector('img')?.alt || '');
  if (lbTotal) lbTotal.textContent = imageSrcs.length;

  const buildLbThumbs = () => {
    if (!lbThumbs) return;
    lbThumbs.innerHTML = '';
    if (imageSrcs.length <= 1) return;
    imageSrcs.forEach((src, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'relative w-14 h-14 rounded-sm overflow-hidden border-2 transition-all duration-300 ' + (i === currentImage ? 'border-primary opacity-100' : 'border-border/40 opacity-50 hover:opacity-80');
      b.setAttribute('aria-label', `View image ${i + 1}`);
      b.innerHTML = `<img src="${src}" alt="" class="absolute inset-0 w-full h-full object-cover" loading="lazy" />`;
      b.addEventListener('click', (e) => {
        e.stopPropagation();
        showLightbox(i);
      });
      lbThumbs.appendChild(b);
    });
  };

  const showLightbox = (index) => {
    if (!lightbox || !lbImage) return;
    currentImage = index;
    lbImage.src = imageSrcs[index];
    lbImage.alt = imageAlts[index] || '';
    if (lbCurrent) lbCurrent.textContent = index + 1;
    buildLbThumbs();
  };

  const openLightbox = (index = currentImage) => {
    if (!lightbox) return;
    lightbox.classList.remove('hidden');
    lightbox.classList.add('flex');
    document.body.style.overflow = 'hidden';
    showLightbox(index);
  };

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.classList.add('hidden');
    lightbox.classList.remove('flex');
    document.body.style.overflow = '';
  };

  const nextLb = () => showLightbox((currentImage + 1) % imageSrcs.length);
  const prevLb = () => showLightbox((currentImage - 1 + imageSrcs.length) % imageSrcs.length);

  mainContainer?.addEventListener('click', () => openLightbox());
  mainContainer?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') openLightbox();
  });
  lightbox?.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });
  lightbox?.querySelector('[data-product-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.querySelector('[data-product-lightbox-next]')?.addEventListener('click', (e) => { e.stopPropagation(); nextLb(); });
  lightbox?.querySelector('[data-product-lightbox-prev]')?.addEventListener('click', (e) => { e.stopPropagation(); prevLb(); });

  document.addEventListener('keydown', (e) => {
    if (!lightbox || lightbox.classList.contains('hidden')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') prevLb();
    if (e.key === 'ArrowRight') nextLb();
  });

  /* ------------------------------------------------------------------ */
  /*  Variant selection                                                  */
  /* ------------------------------------------------------------------ */
  const optionButtons = root.querySelectorAll('[data-variant-option]');
  const variantIdInput = root.querySelector('[data-product-variant-id]');
  const priceEl = root.querySelector('[data-product-price]');
  const stockDot = root.querySelector('[data-product-stock-dot]');
  const stockLabel = root.querySelector('[data-product-stock-label]');
  const atcBtn = root.querySelector('[data-product-form] button[type="submit"]');
  const atcLabel = root.querySelector('[data-product-atc-label]');
  const skuEl = root.querySelector('[data-product-sku]');

  let currentSelections = optionNames.map((optName) => {
    const btn = root.querySelector(`[data-variant-option][data-option-name="${optName}"][aria-pressed="true"]`);
    return btn ? btn.dataset.optionValue : null;
  });

  const findVariant = () => {
    return variants.find((v) =>
      v.options.every((opt, i) => opt === currentSelections[i])
    );
  };

  const updateVariantUI = () => {
    const variant = findVariant();
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl && variant.price) priceEl.innerHTML = variant.price;
    if (skuEl) skuEl.textContent = variant.sku || '';

    if (stockDot) {
      stockDot.classList.toggle('bg-green-500', variant.available);
      stockDot.classList.toggle('bg-destructive', !variant.available);
    }
    if (stockLabel) stockLabel.textContent = variant.available ? 'In Stock' : 'Out of Stock';

    if (atcBtn) atcBtn.disabled = !variant.available;
    if (atcLabel) atcLabel.textContent = variant.available ? 'Add to Basket' : 'Sold Out';

    if (variant.imagePos > 0) {
      showImage(variant.imagePos - 1);
    }

    if (variant.id && history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  };

  const toggleGroupActive = (optName, activeBtn) => {
    const groupBtns = root.querySelectorAll(`[data-variant-option][data-option-name="${optName}"]`);
    groupBtns.forEach((b) => {
      const active = b === activeBtn;
      b.classList.toggle('border-primary', active);
      b.classList.toggle('bg-primary/10', active);
      b.classList.toggle('text-primary', active);
      b.classList.toggle('font-medium', active);
      b.classList.toggle('border-border', !active);
      b.classList.toggle('text-foreground/70', !active);
      b.classList.toggle('hover:border-foreground/40', !active);
      b.setAttribute('aria-pressed', String(active));
    });
  };

  optionButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const optName = btn.dataset.optionName;
      const optValue = btn.dataset.optionValue;

      toggleGroupActive(optName, btn);

      const optIndex = optionNames.indexOf(optName);
      if (optIndex === -1) return;

      currentSelections[optIndex] = optValue;
      updateVariantUI();
    });
  });

  /* ------------------------------------------------------------------ */
  /*  Quantity                                                           */
  /* ------------------------------------------------------------------ */
  const qtyInput = root.querySelector('[data-product-qty]');
  const qtyDec = root.querySelector('[data-product-qty-dec]');
  const qtyInc = root.querySelector('[data-product-qty-inc]');

  qtyDec?.addEventListener('click', () => {
    const v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    qtyInput.value = v;
  });
  qtyInc?.addEventListener('click', () => {
    const v = parseInt(qtyInput.value, 10) + 1;
    qtyInput.value = v;
  });

  /* ------------------------------------------------------------------ */
  /*  Add to cart (AJAX, uses window.cart.add)                           */
  /* ------------------------------------------------------------------ */
  const form = root.querySelector('[data-product-form]');
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!window.cart?.add) {
      form.submit();
      return;
    }
    const variantId = parseInt(variantIdInput.value, 10);
    const quantity = parseInt(qtyInput?.value || '1', 10);
    const sheathToggle = root.querySelector('[data-sheath-toggle]');
    const addSheath = sheathToggle?.checked && sheathToggle.dataset.sheathVariantId;
    if (atcBtn) {
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Adding…';
    }
    try {
      if (addSheath && window.cart.addItems) {
        await window.cart.addItems([
          { id: variantId, quantity },
          {
            id: parseInt(sheathToggle.dataset.sheathVariantId, 10),
            quantity,
            properties: { 'Fitted to': sheathToggle.dataset.sheathFor || '' },
          },
        ]);
      } else {
        await window.cart.add(variantId, quantity);
      }
    } finally {
      if (atcBtn) atcBtn.disabled = false;
      if (atcLabel) {
        const variant = findVariant();
        atcLabel.textContent = variant?.available ? 'Add to Basket' : 'Sold Out';
      }
    }
  });

  /* ------------------------------------------------------------------ */
  /*  Share button (Web Share API + fallback to copy)                    */
  /* ------------------------------------------------------------------ */
  const shareBtn = root.querySelector('[data-product-share]');
  shareBtn?.addEventListener('click', async () => {
    const shareData = {
      title: productData?.title || document.title,
      url: window.location.href,
    };
    if (navigator.share) {
      try { await navigator.share(shareData); } catch (e) { /* user cancelled */ }
    } else if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(shareData.url);
        const original = shareBtn.getAttribute('aria-label');
        shareBtn.setAttribute('aria-label', 'Link copied!');
        setTimeout(() => shareBtn.setAttribute('aria-label', original), 2000);
      } catch (e) { /* clipboard unavailable */ }
    }
  });

  /* ------------------------------------------------------------------ */
  /*  Tabs                                                               */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-tabs]').forEach((tabsRoot) => {
    const btns = tabsRoot.querySelectorAll('.tab-btn');
    const panels = tabsRoot.querySelectorAll('[data-tab-panel]');
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const tabName = btn.dataset.tab;
        btns.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('border-primary', active);
          b.classList.toggle('text-primary', active);
          b.classList.toggle('border-transparent', !active);
          b.classList.toggle('text-foreground/50', !active);
          b.setAttribute('aria-selected', String(active));
        });
        panels.forEach((p) => p.classList.toggle('hidden', p.dataset.tabPanel !== tabName));
      });
    });
  });
})();
